import styled from 'styled-components';
import { Modal } from 'antd';

export const Container = styled.div`
  width: ${props => props.isComplexDesign ? '100%' : '350px'};
  height: calc(100vh - 130px);
  background: ${props => !props.isComplexDesign && 'rgb(37, 41, 45)'};
  overflow-y: ${props => !props.isComplexDesign && 'auto'};
  z-index: 99;
  padding: ${props => !props.isComplexDesign && '15px'};
  display: flex;
  flex-direction: column;
  ::-webkit-scrollbar {
    display: none;
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Title = styled.div`
  height: 60px;
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 700;
  color: rgb(255 255 255 / 0.75);
  padding: 0px 0px 0px 8px;
`;

export const TitleHelp = styled.div`
  margin-left: 10px;
  font-size: 16px;
  font-weight: 700;
  color: rgb(255 255 255 / 0.75);
  padding: 0px 0px 0px 8px;
  .anticon {
    font-size: 18px;
  }
  &:hover {
    cursor: default;
  }
`;

export const ListContainer = styled.div`
  padding: 8px;
  display: flex;
  flex-direction: column;
`;

export const ListGridContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ListItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  justify-content: space-between;
  .variableDetail {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .variable-count {
    font-size: 14px;
    color: #fff;
    font-weight: 600;
    margin-right: 15px;
  }
  .variable-icon {
    width: 24px;
    position: relative;
    margin-right: 10px;
  }
  .variable-length {
    position: absolute;
    left: 50%;
    top: 40%;
    transform: translateX(-50%) translateY(-40%);
    color: #ffffff;
    font-size: 12px;
  }
  .variable-name {
    font-size: 15px;
    line-height: 19px;
    color: #fff;
    font-weight: 600;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 200px;
  }
  .variable-type {
    color: #fff;
    font-size: 11px;
    background: #b1272c;
    border-radius: 30px;
    height: 22px;
    width: 22px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .anticon.anticon-edit {
    color: #fff;
  }
`;

export const EmptyListContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 50px;
`;

export const EmptyListImage = styled.div`
  width: 120px;
  height: 120px;
  margin-bottom: 20px;
  img {
    width: 120px;
    height: 120px;
  }
`;

export const EmptyListHelpText = styled.p`
  font-size: 14px;
  line-height: 19px;
  text-align: center;
  color: rgb(255 255 255 / 0.75);
`;

export const SendEmailModal = styled(Modal)`
  .ant-modal-header {
    padding: 34px 34px 0 !important;
  }
  .ant-modal-footer {
    padding: 0 34px 34px !important;
  }
  .ant-modal-body {
    padding: 0 28px 28px;
  }
  .label {
    padding-block: 8px;
  }
  .label span {
    color: #f00;
  }
`;